// Dutch (NL) translations for Find-2-Day
const nl = {
  translation: {
    "partnersStep3": "Wanneer een bedrijf dat u heeft aangebracht betaalt — het eerste abonnement, een verlenging of een boost — verdient u 50% van die betaling (exclusief btw). Dit verschijnt automatisch in uw Partnerdashboard, bij elke betaling.",
    "partnersLede": "Bent u een Dorpsambassadeur, gemeenschapsgroep of lokale voortrekker? Stel lokale bedrijven voor aan Find-2-Day: u verdient 50% van elke betaling die ze doen (exclusief btw), zolang ze blijven — hun eerste abonnement, elke verlenging en elke boost of gesponsorde post.",
    "partnersCommissionExplainer": "U verdient 50% van alles wat een door u aangebracht bedrijf betaalt: het eerste abonnement, elke maandelijkse of jaarlijkse verlenging en elke boost of gesponsorde post. Prijzen zijn inclusief 21% btw; uw commissie wordt berekend over het bedrag exclusief btw.",
    "partnersRenewalHeading": "Abonnementen & verlengingen",
    "partnersRenewalDesc": "50% van de eerste betaling en van elke verlenging van een aangebracht bedrijf, zolang het geabonneerd blijft.",
    "partnersPoint2": "Zodra ze betalen voor een abonnement, verlenging, boost of gesponsorde post, ontvangt u 50% van wat ze betaalden (exclusief btw).",
    "partnersPoint3": "Elk bedrijf dat u aanbrengt is blijvend aan u gekoppeld. Zolang ze blijven betalen, blijft u 50% verdienen — levenslang.",
    "affEarnTitle": "Wat u per plan verdient",
    "affEarnIntro": "Prijzen zijn inclusief 21% btw. Uw commissie van 50% wordt berekend over het bedrag exclusief btw. Geldige abonnementen betalen u levenslang — de eerste betaling en elke verlenging.",
    "affEarnColPlan": "Plan",
    "affEarnColPrice": "Prijs (incl. btw)",
    "affEarnColCommission": "Uw commissie (per betaling)",
    "affEarnPerMonth": "/maand",
    "affEarnPerYear": "/jaar",
    "affEarnPlanBasic": "Basic",
    "affEarnPlanPlus": "Business Plus",
    "affEarnLifetimeNote": "U verdient de bovenstaande commissie bij hun eerste betaling en bij elke verlenging, zolang ze geabonneerd blijven.",
    "affEarnBoostNote": "Boosts & gesponsorde posts: u verdient ook 50% van elke betaalde boost of gesponsorde post die een aangebracht bedrijf koopt.",
    "verifyEmailWarn": "Verifieer uw e-mail om commissie-uitbetalingen in te schakelen.",
    "resendVerification": "E-mail opnieuw versturen",
    "sending": "Versturen…",
    "verifyResent": "Verificatie-e-mail verzonden — controleer uw inbox.",
    "payoutHoldWarn": "Uw bankgegevens zijn onlangs gewijzigd, daarom zijn uitbetalingen tijdelijk geblokkeerd voor de veiligheid.",
    "clawbackWarn": "Een openstaand saldo van €{{amt}} uit een terugbetaling/chargeback wordt verrekend met toekomstige commissies.",
    "downloadEarnings": "Verdienstenoverzicht (CSV)",
    "downloadPayouts": "Uitbetalingsoverzicht (CSV)",
    "partnersPoint1": "Bedrijven kunnen zich bij Find-2-Day aansluiten met een permanente GRATIS basisvermelding in de directory. Optionele betaalde abonnementen en promotiediensten zijn beschikbaar. Bestaande oprichtende bedrijven behouden hun oorspronkelijk beloofde 12 maanden gratis.",
    "partnersPoint4": "Commissies worden 30 dagen vastgehouden. Als een betaling wordt terugbetaald of een geschil wordt gewonnen, kan de bijbehorende commissie worden teruggedraaid. Reeds uitbetaalde commissies kunnen worden verrekend met toekomstige inkomsten.",
    "howPayoutsRule6": "Als een betaling wordt terugbetaald of een geschil wordt gewonnen, kan de bijbehorende commissie worden teruggedraaid — ook reeds uitbetaalde commissies, die met toekomstige inkomsten kunnen worden verrekend.",
    "lifetimeRenewalEarningsHint": "U gaat dit verdienen zodra uw aangebrachte bedrijven verlengen. Verder niets te doen — wij houden het voor u bij.",
    "renewalCommissionTooltip": "Commissie verdiend omdat dit bedrijf zijn abonnement heeft verlengd",
    "communityPartner": {
      "title": "Word Community Partner",
      "label": "Word Community Partner",
      "tagline": "Verdien ",
      "taglineRest": " levenslange commissie op alles wat uw aangebrachte bedrijven betalen (excl. btw).",
      "cta": "Meer informatie"
    },
    "membership": {
      "chooseTitle": "Kies je lidmaatschap",
      "chooseSubtitle": "Begin gratis of ontgrendel je volledige profiel. Prijzen incl. btw.",
      "freeForever": "Voor altijd gratis · geen kaart nodig",
      "chooseFree": "Kies Gratis Vermelding",
      "month": "maand",
      "year": "jaar",
      "trial60": "Eerste 60 dagen gratis",
      "ivaIncluded": "incl. btw",
      "chooseBasic": "Kies Basic",
      "plusName": "Business Plus",
      "orAnnual": "of",
      "choosePlusMonthly": "Maandelijks",
      "choosePlusAnnual": "Jaarlijks",
      "consentNote": "Betaalde abonnementen beginnen met een gratis proefperiode van 60 dagen. Er wordt pas afgeschreven na afloop van de proefperiode, en alleen als je toestemming hebt gegeven. Altijd opzegbaar.",
      "freeBadge": "Gratis Vermelding",
      "freeTitle": "Gratis vermelding — €0 voor altijd",
      "freeBody": "Je basisvermelding (bedrijfsnaam, categorie en plaats) gaat live na goedkeuring. Geen kaart nodig. Je kunt altijd upgraden naar Basic of Business Plus om al je gegevens te tonen.",
      "paidBody": "Je vermelding gaat live na goedkeuring. De eerste 60 dagen wordt er NIETS afgeschreven. Na de gratis proefperiode wordt je kaart automatisch belast, alleen als je toestemming hebt gegeven — en je kunt daarvoor altijd opzeggen.",
      "firstChargeOn": "Eerste afschrijving (als je doorgaat):",
      "checkoutNotReady": "Veilig betalen met kaart voor betaalde abonnementen wordt in de volgende stap ingeschakeld (Stripe-testmodus). Je registratiegegevens zijn compleet en klaar — er is niets afgeschreven.",
      "freeCta": "Mijn gratis vermelding aanmaken",
      "paidCta": "Doorgaan — mijn 60 gratis dagen starten",
      "freeName": "Gratis Vermelding",
      "basicName": "Basic",
      "feat": {
        "free": ["Bedrijfsnaam", "Categorie", "Plaats", "Basiszichtbaarheid in de gids"],
        "basic": ["Eerste 60 dagen gratis", "Volledige bedrijfsomschrijving", "Telefoon en contactgegevens", "Website en social media", "Bedrijfsfoto's", "Adres, kaart en route", "Standaard zichtbaarheid in zoekresultaten"],
        "plus": ["Eerste 60 dagen gratis", "Alles van Basic", "Business Plus-badge", "Promoot evenementen en speciale aanbiedingen"]
      }
    },
    "listShare": {
      "today": "Boodschappen van Vandaag",
      "todayHint": "Je huidige boodschappen · prijzen vergelijken",
      "myLists": "Mijn Lijsten",
      "noLists": "Maak lijsten voor alles – boodschappen, klussen, brandhout, huisdieren, tuin…",
      "newList": "Nieuwe Lijst",
      "namePh": "Lijstnaam (bijv. Weekboodschappen, Klussen, Brandhout)",
      "nameRequired": "Geef de lijst een naam",
      "kind_personal": "Persoonlijk",
      "kind_calendar": "Huishouden",
      "kind_direct": "Gedeeld",
      "hintPersonal": "Alleen voor jou.",
      "hintCalendar": "Gedeeld met iedereen in die agenda.",
      "hintDirect": "Deel met specifieke mensen via e-mail.",
      "pickCalendar": "Kies een agenda…",
      "create": "Aanmaken",
      "created": "Lijst aangemaakt",
      "rename": "Hernoemen",
      "delListConfirm": "Deze lijst verwijderen? De artikelen worden verwijderd.",
      "share": "Met iemand delen",
      "shared": "Lijst gedeeld",
      "invite": "Uitnodigen",
      "emailPh": "E-mail van Find-2-Day-gebruiker",
      "editingShared": "Je werkt aan een gedeelde lijst",
      "shareHelp": "Mensen die je uitnodigt kunnen deze lijst bekijken en bewerken, en kunnen de namen en e-mailadressen zien van de anderen die de lijst delen.",
      "remove": "Verwijderen",
      "addToWhich": "Toevoegen aan…",
      "addedToList": "{{n}} toegevoegd aan {{list}}",
      "addToListN": "Aan lijst toevoegen ({{n}})",
      "copySelectedToList": "Naar lijst kopiëren ({{n}})",
      "listEmpty": "Nog geen producten. Voeg toe wat je koopt.",
      "select": "Selecteren",
      "compareThis": "Deze Lijst Vergelijken",
      "addAll": "Hele lijst toevoegen",
      "addSelected": "Geselecteerde toevoegen ({{n}})",
      "addSelectedShort": "Geselecteerde toevoegen",
      "addWholeShop": "Hele boodschappen toevoegen",
      "pickItems": "Vink de artikelen aan die je nodig hebt",
      "copiedToday": "{{n}} toegevoegd aan Boodschappen van Vandaag",
      "itemsN": "{{n}} artikelen",
      "repeatShop": "Laatste Boodschappen Herhalen",
      "repeatHint": "Voeg artikelen van je laatste bon toe",
      "repeatEmpty": "Geen eerdere boodschappen gevonden. Scan eerst een bon.",
      "favourite": "Favoriet",
      "favAdded": "Toegevoegd aan Favorieten",
      "favRemoved": "Verwijderd uit Favorieten"
    },
    "priceEdit": {
      "title": "Prijsdetails", "edit": "Prijs bewerken", "delete": "Verwijderen", "save": "Wijzigingen opslaan", "cancel": "Annuleren",
      "confirmDelete": "Deze prijs definitief verwijderen? Dit kan niet ongedaan worden gemaakt.", "confirmYes": "Ja, verwijderen",
      "productName": "Productnaam", "price": "Prijs", "brand": "Merk", "packSize": "Verpakking / maat", "quantity": "Aantal",
      "shop": "Leverancier / winkel", "town": "Plaats / locatie", "date": "Datum vastgelegd", "notes": "Notities",
      "notesPh": "bijv. in de aanbieding, loyaliteitsprijs, grootverpakking…", "optional": "optioneel",
      "saved": "Prijs bijgewerkt", "deleted": "Prijs verwijderd",
      "errName": "Voer een productnaam in", "errPrice": "Voer een geldige prijs in",
      "errSave": "Kon de prijs niet bijwerken", "errDelete": "Kon de prijs niet verwijderen"
    },
    "priceHistory": {
      "title": "Prijsgeschiedenis", "none": "Nog geen prijsgeschiedenis",
      "noneHint": "Zodra er meer vastgelegde prijzen zijn voor dit product bij deze winkel, verschijnt hier een trend.",
      "latest": "LAATSTE", "rose": "Prijs gestegen", "fell": "Prijs gedaald", "flat": "Ongeveer gelijk"
    },
    "pricePromo": {
      "title": "Price-2-Day Promoties",
      "subtitle": "Promoot een productaanbieding bij shoppers in de buurt",
      "slots": "Plaatsen",
      "suspendedNote": "Uw bedrijf is momenteel uitgesloten van promoties. Neem contact op met support.",
      "new": "Nieuwe promotie",
      "embedTitle": "Mijn promoties",
      "promoteItem": "Een product promoten",
      "boostAgain": "Opnieuw promoten",
      "noSlots": "Geen promotieplaatsen over. Archiveer een actieve om een plaats vrij te maken.",
      "editTitle": "Promotie bewerken",
      "createTitle": "Promotie aanmaken",
      "product": "Product",
      "productPh": "bijv. Olijfolie 2L",
      "brand": "Merk",
      "pack": "Verpakking / maat",
      "normalPrice": "Normale prijs",
      "promoPrice": "Actieprijs",
      "description": "Omschrijving",
      "town": "Plaats / gebied",
      "branch": "Winkel / filiaal",
      "optional": "optioneel",
      "start": "Startdatum",
      "end": "Einddatum",
      "availability": "Beschikbaarheidstekst",
      "availabilityPh": "bijv. Zolang de voorraad strekt",
      "photo": "Foto",
      "photoError": "Kon foto niet uploaden",
      "save": "Opslaan",
      "publish": "Publiceren",
      "updated": "Promotie bijgewerkt",
      "published": "Promotie is nu live",
      "submitted": "Promotie ingediend ter beoordeling",
      "archived": "Promotie gearchiveerd",
      "viewActive": "Actief",
      "viewExpired": "Verlopen",
      "empty": "Nog geen promoties hier.",
      "ends": "eindigt",
      "sponsored": "Gesponsord",
      "sponsoredHint": "Betaalde aanbieding — geen deel van de prijsvergelijking",
      "needProduct": "Voer een productnaam in",
      "needPromoPrice": "Voer een actieprijs in",
      "needEnd": "Kies een einddatum",
      "saveError": "Kon promotie niet opslaan",
      "needDuration": "Kies een promotieduur",
      "publishedFree": "Je GRATIS promotie is nu live",
      "ended": "Promotie beëindigd",
      "startHint": "laat leeg voor vandaag",
      "duration": "Promotieduur",
      "days": "dagen",
      "free": "GRATIS",
      "willEnd": "Eindigt",
      "testMode": "Preview-testmodus — prijs getoond, geen echte afschrijving",
      "introAvailable": "Je eerste promotie van 7 dagen is GRATIS (één per bedrijf).",
      "introUsed": "Gratis introductiepromotie gebruikt.",
      "viewLive": "Live",
      "viewScheduled": "Gepland",
      "edit": "Bewerken",
      "endEarly": "Vroegtijdig beëindigen",
      "archive": "Archiveren",
      "status": { "live": "Live", "scheduled": "Gepland", "pending": "In beoordeling", "suspended": "Opgeschort", "expired": "Verlopen", "archived": "Gearchiveerd" }
    },
    "price": {
      "tagline": "Scan een kassabon om de prijzen te lezen",
      "homeHeadline": "Samen geld besparen",
      "homeTagline": "Echte prijzen. Echte mensen. Een sterkere gemeenschap.",
      "homeIntro": "Scan je kassabonnen, deel prijzen, vergelijk winkels en help iedereen de beste aanbiedingen te vinden.",
      "actListTitle": "Mijn boodschappenlijst",
      "actListSub": "Wat moet ik kopen?",
      "actSearchTitle": "Goedkoopste prijs vinden",
      "actSearchSub": "Vergelijk prijzen bij jou in de buurt",
      "actScanTitle": "Prijzen scannen & delen",
      "actScanSub": "De prijzen van mijn boodschappen toevoegen",
      "helpTitle": "Jouw kassabonnen helpen iedereen!",
      "helpBody": "Wanneer je je kassabon scant, gebruiken we alleen de productinformatie en prijzen om jou en anderen te helpen de beste aanbiedingen te vinden.",
      "helpPrivacy": "We verzamelen of bewaren GEEN persoonlijke gegevens, betaal-/kaartgegevens of de foto van de kassabon.",
      "buyOftenTitle": "Wat ik vaak koop",
      "buyOftenSub": "Snel aan mijn lijst toevoegen",
      "dealsBtnTitle": "Aanbiedingen van vandaag",
      "dealsBtnSub": "Speciale aanbiedingen bij jou in de buurt",
      "backToMenu": "Terug",
      "scanWhyTitle": "Help iedereen besparen",
      "scanWhyBody": "Scan je kassabon en wij lezen de prijzen. Jouw prijzen helpen jou en anderen in de gemeenschap te zien waar producten het goedkoopst zijn.",
      "savedCommunityTitle": "Bedankt! \u2764\ufe0f",
      "savedCommunityBody": "Je prijzen zijn toegevoegd. Je hebt zojuist andere shoppers geholpen betere prijzen te vinden.",
      "slAddHeading": "Wat heb je nodig?",
      "quickAddTitle": "Snel toevoegen",
      "regularTitle": "Wat ik regelmatig koop",
      "addToListBtn": "Toevoegen",
      "buyOftenEmpty": "Producten die je vaak koopt verschijnen hier, klaar om met één tik toe te voegen.",
      "manageProductsLink": "Mijn opgeslagen producten beheren",
      "addedToListToast": "Toegevoegd aan je boodschappenlijst",
      "tabScan": "Scannen",
      "tabSearch": "Zoeken",
      "tabFav": "Favorieten",
      "tabDeals": "Aanbiedingen",
      "dist": { "pick": "Kies je plaats voor afstanden", "list": "Lijst", "map": "Kaart", "soon": "Binnenkort", "directions": "Route", "unavailable": "Locatie nog niet beschikbaar", "approxTravel": "Afstand ca.", "extraTravel": "Extra reis ca.", "productSaving": "Productbesparing", "vsOne": "t.o.v. Eén winkel", "partial": "Sommige locaties nog niet beschikbaar", "nearestNone": "Nog geen betrouwbaar gelokaliseerde winkel voor deze artikelen", "knownFor": "Bekende recente prijzen voor {{covered}}/{{total}} artikelen" },
      "reviewNote": "Controleer wat de AI heeft gelezen, corrigeer fouten en sla op. De bonfoto wordt nooit bewaard – alleen de prijzen.",
      "scanTitle": "Kassabon scannen",
      "scanBlurb": "Fotografeer een bon of kies er een van je telefoon. Werkt met elke winkel en elke taal.",
      "receiptPrivacy": "Bonprivacy: Je bon wordt alleen gebruikt om product- en prijsinformatie te lezen. De bonafbeelding wordt niet openbaar getoond en wordt niet permanent opgeslagen door Price-2-Day. Persoonlijke en betaalgegevens worden niet toegevoegd aan de Price-2-Day-prijsdatabase.",
      "signInToScan": "Log in om een bon te scannen en in te dienen.",
      "signIn": "Inloggen",
      "takePhoto": "Foto maken",
      "choosePhoto": "Bestaande foto kiezen",
      "readingReceipt": "Bon wordt gelezen…",
      "receiptPreviewAlt": "bonvoorbeeld",
      "reviewTitle": "Controleren & corrigeren",
      "reviewSubtitle": "Bewerk elk veld dat de AI verkeerd heeft gelezen.",
      "fShop": "Winkel",
      "fLocation": "Locatie / filiaal",
      "fDate": "Datum",
      "fCurrency": "Valuta",
      "fTotal": "Bontotaal",
      "itemsLabel": "ARTIKELEN ({{count}})",
      "noItems": "Geen artikelen herkend.",
      "itemN": "Artikel {{n}}",
      "removeItem": "Artikel verwijderen",
      "fDesc": "Omschrijving (zoals gedrukt)",
      "fBrand": "Merk",
      "fPackSize": "Verpakkingsgrootte",
      "fQty": "Aantal",
      "fUnitPrice": "Stukprijs",
      "fLineTotal": "Regeltotaal",
      "fDiscount": "Korting / aanbieding",
      "confirmSave": "Prijzen bevestigen & opslaan",
      "saving": "Opslaan…",
      "cancel": "Annuleren",
      "signInHint": "Je moet inloggen om op te slaan.",
      "savedTitle": "Bon succesvol toegevoegd",
      "savedBody": "Bedankt voor je bijdrage. Je kunt zoveel bonnen toevoegen als je wilt.",
      "scanAnother": "Nog een bon scannen",
      "searchPlaceholder": "Zoek een product, bijv. Olijfolie of ACEITE",
      "searchBtn": "Zoeken",
      "sortLabel": "Sorteren:",
      "sortLowest": "Laagste prijs",
      "sortRecent": "Meest recent",
      "sortNearest": "Dichtstbij",
      "noResults": "Geen passende producten gevonden. Probeer andere woorden.",
      "asPrinted": "zoals gedrukt",
      "lowestPrice": "Laagste prijs",
      "lowestUnit": "Laagste stukprijs",
      "unknownShop": "Onbekende winkel",
      "shopsCount": "{{count}} winkel(s)",
      "receiptDated": "Bon gedateerd",
      "offer": "Aanbieding",
      "freshRecent": "Recent",
      "freshOlder": "Ouder",
      "freshHistorical": "Historisch",
      "freshUnknown": "Onbekend",
      "disclaimer": "De prijzen op Price-2-Day zijn gebaseerd op informatie van de community. Ze kunnen verouderd zijn of per winkel en tijd verschillen. Controleer altijd in de winkel vóór aankoop.",
      "errMin2": "Typ minstens 2 tekens om te zoeken.",
      "errHeic": "Kan dat fotoformaat niet lezen. Probeer JPG of PNG.",
      "errChooseImage": "Kies een bonafbeelding.",
      "errNoData": "Er konden geen gegevens worden geëxtraheerd. Probeer een scherpere foto.",
      "errScan": "Kan de bon niet lezen. Probeer opnieuw.",
      "errNoItems": "Voeg minstens één artikel met omschrijving toe voordat je opslaat.",
      "errSignIn": "Log in om bonprijzen op te slaan.",
      "errDuplicate": "Je hebt deze bon al ingediend.",
      "errSaveGeneric": "Opslaan mislukt. Probeer opnieuw.",
      "errSearch": "Zoeken mislukt. Probeer opnieuw.",
      "tabProducts": "Mijn producten",
      "tabList": "Boodschappenlijst",
      "signInCta": "Inloggen",
      "errGeneric": "Er ging iets mis. Probeer opnieuw.",
      "edit": "Bewerken",
      "delete": "Verwijderen",
      "back": "Terug",
      "mpSignIn": "Log in om je privélijst met producten die je koopt te bewaren.",
      "mpAddTitle": "Product toevoegen",
      "mpNamePh": "Productnaam (bijv. Melk)",
      "mpBrandPh": "Merk (optioneel)",
      "mpPackPh": "Verpakkingsgrootte (optioneel)",
      "mpAddBtn": "Toevoegen",
      "mpFromReceipt": "Van bon",
      "mpNameRequired": "Voer een productnaam in.",
      "mpDuplicate": "Dat product staat al in Mijn producten.",
      "mpAdded": "Toegevoegd aan Mijn producten.",
      "mpEmpty": "Nog geen producten. Voeg toe wat je regelmatig koopt.",
      "mpToList": "Moet kopen",
      "mpPickReceipt": "Kies een van je opgeslagen bonnen",
      "mpNoReceipts": "Je hebt nog geen opgeslagen bonnen.",
      "mpTickItems": "Vink de items aan voor Mijn producten",
      "mpAddSelected": "Selectie toevoegen",
      "mpPickOne": "Selecteer minstens één item.",
      "mpFromReceiptDone": "{{added}} toegevoegd · {{skipped}} al aanwezig",
      "itemsCount": "{{count}} item(s)",
      "status_have": "Genoeg",
      "status_low": "Raakt op",
      "status_need": "Moet kopen",
      "slSignIn": "Log in om je privéboodschappenlijst te bewaren.",
      "slAddTitle": "Aan boodschappenlijst toevoegen",
      "slNamePh": "Typ een item, bijv. Brood",
      "slNameRequired": "Voer een item in.",
      "slIncreased": "Aantal op je lijst verhoogd.",
      "slAdded": "Toegevoegd aan je boodschappenlijst.",
      "slFromProductsHint": "Tip: tik op \"Moet kopen\" bij een product in Mijn producten om het hier toe te voegen.",
      "slEmpty": "Je boodschappenlijst is leeg.",
      "slTick": "Als gekocht markeren",
      "slUntick": "Terug naar lijst",
      "slBought": "Gekocht ({{n}})",
      "slClearCompleted": "Voltooide wissen",
      "slCleared": "{{n}} item(s) gewist.",
      "buyAgain": "Opnieuw kopen",
      "buyAgainDone": "Toegevoegd aan je boodschappenlijst.",
      "addToMyProductsTitle": "Deze toevoegen aan Mijn producten?",
      "addToMyProductsBtn": "Selectie toevoegen aan Mijn producten",
      "addedToMyProducts": "Toegevoegd aan Mijn producten.",
      "cmpButton": "Mijn boodschappen vergelijken",
      "cmpTitle": "Mijn boodschappen vergelijken",
      "cmpOneShop": "Eén winkel",
      "cmpTwoShops": "Twee winkels",
      "cmpCheapest": "Goedkoopst",
      "cmpNearest": "Dichtstbij",
      "cmpEstTotal": "Geschat totaal",
      "cmpSaving": "Geschatte besparing",
      "cmpSubtotal": "Subtotaal",
      "cmpCoverage": "Prijzen gevonden voor {{found}} van {{total}} items.",
      "cmpNoRecent": "Geen recente vergelijking beschikbaar",
      "cmpNoData": "Nog geen prijzen beschikbaar voor deze optie.",
      "cmpDisclaimer": "Geschat op basis van bonprijzen van de community. Prijzen kunnen zijn gewijzigd."
    },
    "notes": {
      "back": "Notities", "overviewHint": "Privé- en gedeelde notities voor deze kalender.",
      "createNote": "Notitie maken", "editNote": "Notitie bewerken", "title": "Titel", "text": "Tekst",
      "textPlaceholder": "Schrijf hier je notitie …", "colour": "Kleur", "privacy": "Zichtbaarheid",
      "private": "Privé", "shared": "Gedeeld", "privateHint": "Alleen jij kunt deze notitie zien.",
      "sharedHint": "Kies na het opslaan kalenderleden om deze mee te delen.",
      "formHint": "Geef je notitie een titel en tekst. Notities zijn privé, tenzij je ze deelt.",
      "save": "Opslaan", "cancel": "Annuleren", "open": "Openen", "edit": "Bewerken", "delete": "Verwijderen",
      "copy": "Tekst kopiëren", "share": "Delen", "manageSharing": "Delen beheren",
      "memberEmail": "E-mail van lid",
      "shareDialogHint": "Voer het exacte e-mailadres van een kalenderlid in. Het moet al bij deze kalender horen.",
      "noneShared": "Nog met niemand gedeeld.", "sharedWith": "Gedeeld met", "sharedTag": "met jou gedeeld",
      "readOnly": "Je hebt alleen leestoegang tot deze notitie.", "empty": "Deze notitie heeft nog geen tekst.",
      "emptyTitle": "Nog geen notities", "emptyHint": "Maak je eerste privé- of gedeelde notitie.",
      "deleteNote": "Notitie verwijderen",
      "deleteConfirm": "Hiermee wordt de notitie definitief verwijderd. Dit kan niet ongedaan worden gemaakt.",
      "created": "Notitie gemaakt", "updated": "Notitie bijgewerkt", "deleted": "Notitie verwijderd",
      "copied": "Notitie naar klembord gekopieerd",
      "shareCopied": "Delen hier niet mogelijk – notitie in plaats daarvan gekopieerd", "shareSaved": "Delen bijgewerkt",
      "loadError": "Kan notities niet laden", "openError": "Deze notitie is niet beschikbaar",
      "saveError": "Kan notitie niet opslaan", "deleteError": "Kan notitie niet verwijderen",
      "copyError": "Kan notitie niet kopiëren", "shareError": "Kan notitie niet delen",
      "shareUpdateError": "Kan delen niet bijwerken",
      "dragHandle": "Sleep om te herordenen", "reorderHint": "Sleep een notitie aan het handvat om te herordenen, of gebruik de ▲ ▼ pijlen",
      "moveUp": "Omhoog", "moveDown": "Omlaag", "reorderError": "Kan niet herordenen"
    },
    "lists": {
      "back": "Lijsten", "overviewHint": "Privé- en gedeelde checklists voor deze kalender.",
      "createList": "Lijst maken", "editList": "Lijst bewerken", "name": "Naam", "colour": "Kleur",
      "privacy": "Zichtbaarheid", "private": "Privé", "shared": "Gedeeld",
      "privateHint": "Alleen jij kunt deze lijst zien en beheren.",
      "sharedHint": "Jij bepaalt precies welke kalenderleden er toegang toe hebben.",
      "formHint": "Geef je lijst een naam, kies een kleur en bepaal wie hem mag zien.",
      "save": "Opslaan", "cancel": "Annuleren", "delete": "Verwijderen", "duplicate": "Dupliceren",
      "editItem": "Item bewerken", "deleteList": "Lijst verwijderen",
      "deleteConfirm": "Hiermee worden de lijst en alle items definitief verwijderd. Dit kan niet ongedaan worden gemaakt.",
      "manageSharing": "Delen beheren", "memberEmail": "E-mail van lid",
      "shareHint": "Voer het exacte e-mailadres van een kalenderlid in. Het moet al bij deze kalender horen.",
      "noneShared": "Nog met niemand gedeeld.", "sharedWith": "Gedeeld met", "sharedTag": "met jou gedeeld",
      "readOnly": "Je hebt alleen leestoegang tot deze lijst.", "noItems": "Nog geen items.",
      "newItem": "Nieuw item", "itemText": "Item", "itemPlaceholder": "bijv. Melk",
      "quantity": "Aantal", "qty": "Aant.", "done": "klaar", "emptyTitle": "Nog geen lijsten",
      "emptyHint": "Maak je eerste privé- of gedeelde lijst.", "dragHandle": "Sleep om te herordenen",
      "reorderHint": "Sleep aan het handvat om te herordenen, of gebruik de ▲ ▼ pijlen", "reorderListsHint": "Sleep een lijst aan het handvat om te herordenen",
      "itemTextRequired": "Itemtekst is verplicht", "created": "Lijst gemaakt", "updated": "Lijst bijgewerkt",
      "deleted": "Lijst verwijderd", "duplicated": "Er is een privékopie gemaakt", "itemUpdated": "Item bijgewerkt",
      "loadError": "Kan lijsten niet laden", "openError": "Deze lijst is niet beschikbaar",
      "saveError": "Kan lijst niet opslaan", "deleteError": "Kan lijst niet verwijderen",
      "dupError": "Kan lijst niet dupliceren", "itemError": "Kan item niet toevoegen",
      "itemError2": "Kan item niet bijwerken", "itemDelError": "Kan item niet verwijderen",
      "reorderError": "Kan volgorde niet wijzigen", "shareSaved": "Delen bijgewerkt",
      "shareError": "Kan delen niet bijwerken"
    },
    "bookingCal": {
      "pickDate": "Kies een datum",
      "repeat": "Herhalen", "repeatEditHint": "wijzig hoe deze boeking wordt herhaald",
      "repeatNone": "Niet herhalen", "repeatDaily": "Elke dag", "repeatWeekly": "Elke week",
      "repeatBiweekly": "Elke 2 weken", "repeatMonthly": "Elke maand", "repeatCustom": "Aangepast",
      "endDateRequired": "Kies een einddatum voor de herhaling",
      "repeatUpdated": "Herhaling bijgewerkt – {n} boekingen", "repeatRemoved": "Deze boeking wordt niet meer herhaald",
      "savedEdit": "Boeking bijgewerkt", "savedDupGroup": "Alle gedupliceerde boekingen bijgewerkt",
      "deleted": "Boeking naar de prullenbak verplaatst", "skipDate": "Deze datum overslaan",
      "skipDateQ": "Deze datum overslaan?",
      "skipDateDesc": "Alleen {date} wordt verwijderd. De rest van de herhalende reeks blijft ongewijzigd. Je kunt hem later herstellen vanuit de prullenbak.",
      "dateSkipped": "Deze datum is overgeslagen – de rest van de herhaling blijft ongewijzigd",
      "repeatsPrefix": "Herhaalt zich", "recEveryDay": "elke dag", "recEveryNDays": "elke {n} dagen",
      "recEveryWeek": "elke week", "recEvery2Weeks": "elke 2 weken", "recEveryNWeeks": "elke {n} weken",
      "recOn": "op", "recMonthly": "maandelijks", "recEveryNMonths": "elke {n} maanden", "recUntil": "tot {d}",
      "recForN": "voor {n} keer", "repeats": "Herhalende boeking", "repeatsShort": "Herhaalt zich",
      "dupDelTitle": "Gedupliceerde boeking verwijderen",
      "dupDelIntro": "Deze boeking is een van {n} die samen zijn gemaakt met Dupliceren.",
      "dupDelThis": "Alleen deze boeking verwijderen", "dupDelAll": "Alle gedupliceerde boekingen verwijderen",
      "dupDelAllGo": "Alles verwijderen", "dupDelSelect": "Boekingen selecteren om te verwijderen",
      "dupDelSelectedGo": "Geselecteerde verwijderen",
      "dupDelAllConfirm": "Alle {n} gedupliceerde boekingen verwijderen? Ze worden naar de prullenbak verplaatst.",
      "dupDelPickOne": "Selecteer ten minste één boeking.", "dupDelDone": "{n} boeking(en) verwijderd",
      "dupDelPartial": "{ok} verwijderd; {fail} mislukt",
      "dupDelFailed": "Kan de gedupliceerde boekingen niet verwijderen",
      "listsNav": "Lijsten", "notesNav": "Notities"
    },
    "eventCreateFailed": "Evenement kon niet worden aangemaakt. Probeer het opnieuw.",
    "eventUpdateFailed": "Evenement kon niet worden bijgewerkt. Probeer het opnieuw.",
    "eventsBlockedTrialEnded": "Je proefperiode is afgelopen. Voeg een betaalmethode toe om weer evenementen te publiceren.",
    "eventsBlockedPlan": "Je huidige abonnement bevat geen evenementen. Upgrade om evenementen te plaatsen.",
    "eventsBlockedMax": "Je hebt je limiet van {{max}} actieve evenementen bereikt. Archiveer hieronder een evenement of upgrade naar Featured voor meer.",
    "eventsActiveHint": "Actief = alleen lopende en aankomende evenementen. Verlopen/afgelopen evenementen tellen niet mee voor je limiet.",
    "home": {
      "heroTagline": "Alles wat er gebeurt in jouw stad.",
      "startCardTitle": "Starten",
      "startCardDesc": "Ontdek alles wat er gebeurt in jouw stad.",
      "businessCardTitle": "Bedrijven",
      "businessCardDesc": "Promoot je bedrijf, organisatie of gemeenschapsgroep.",
      "discoverTitle": "Ontdek bedrijven & evenementen",
      "localAlertsTitle": "Community-veiligheidshub",
      "classifiedsTitle": "Verkopen · Verloren · Gevonden",
      "bankHolidaysTitle": "Feestdagen",
      "emergencyTitle": "Noodnummers",
      "businessSignInTitle": "Heb je al een bedrijfsaccount? Inloggen",
      "businessCalendarTitle": "Bedrijfsagenda"
    },
    "frontpage": {
      "claimExistingBusinessTitle": "Claim of voeg een bedrijf toe",
      "charityApplyTitle": "Gemeenschaps- / liefdadigheidsvermelding"
    },
    "frontpageEarnCommission": "Word een community-partner",
    "dismiss": "Sluiten",
    "safetyOptInTitle": "Mis nooit een veiligheidsmelding",
    "safetyOptInBody": "Ontvang officiële veiligheidsmeldingen rechtstreeks op je telefoon, zodat je nooit belangrijke informatie uit je gemeenschap mist.",
    "safetyOptInCta": "Telefoonmeldingen inschakelen",
    "safetyOptInEnabling": "Inschakelen…",
    "safetyOptInError": "Meldingen konden niet worden ingeschakeld. Probeer het opnieuw.",
    "appTitle": "Find-2-day",
    "appBadgeTitle": "Meldingen op je telefoon",
    "appBadgeDesc": "Toon een badge op het app-icoon en een melding wanneer er een nieuwe veiligheidsmelding binnenkomt — ook als de app gesloten is.",
    "appBadgeUnsupported": "Niet ondersteund op dit apparaat",
    "appBadgeEnabled": "Telefoonmeldingen aan. Installeer Find-2-Day op je startscherm voor de icoonbadge.",
    "appBadgeFallback": "Je apparaat toont meldingen maar geen icoonbadge — je krijgt nog steeds de in-app belindicator.",
    "appTagline": "Vind lokale bedrijven, ervaringen, evenementen en activiteiten bij jou in de buurt",
    "getStarted": "Aan de slag",
    "listYourBusiness": "Registreer je bedrijf",
    "signIn": "Inloggen",
    "joinBusiness": "Meedoen als bedrijf",
    "categories": {
      "food": "Eten & Drinken",
      "music": "Muziek & Nachtleven",
      "family": "Familieactiviteiten",
      "offers": "Aanbiedingen",
      "wellbeing": "Welzijn & meer"
    },
    "nav": {
      "discover": "Ontdekken",
      "favorites": "Favorieten",
      "events": "Evenementen",
      "offers": "Aanbiedingen",
      "profile": "Profiel",
      "forSale": "Verkopen / Verloren / Gevonden",
      "communityHub": "Community"
    },
    "welcomeBack": "Welkom terug!",
    "signInSubtitle": "Log in om verder te ontdekken",
    "emailOrUsername": "E-mail",
    "password": "Wachtwoord",
    "rememberMe": "Onthoud mij",
    "forgotPassword": "Wachtwoord vergeten?",
    "forgotPasswordTitle": "Wachtwoord vergeten?",
    "forgotPasswordDesc": "Vul je e-mailadres in en we sturen een link om je wachtwoord te resetten.",
    "forgotPasswordError": "Er ging iets mis. Probeer het opnieuw.",
    "sendResetLink": "Link versturen",
    "sending": "Versturen...",
    "checkYourEmail": "Controleer je e-mail",
    "resetEmailSent": "Als er een account bestaat, hebben we een resetlink gestuurd. Controleer je inbox en spammap.",
    "backToSignIn": "Terug naar inloggen",
    "setNewPassword": "Nieuw wachtwoord instellen",
    "setNewPasswordDesc": "Kies een sterk wachtwoord van minimaal 6 tekens.",
    "newPassword": "Nieuw wachtwoord",
    "confirmPassword": "Wachtwoord bevestigen",
    "resetPassword": "Wachtwoord resetten",
    "resetting": "Resetten...",
    "passwordReset": "Wachtwoord gereset",
    "passwordResetSuccess": "Je wachtwoord is succesvol gereset.",
    "invalidResetLink": "Ongeldige link",
    "invalidResetLinkDesc": "Deze link is ongeldig of verlopen.",
    "requestNewLink": "Nieuwe link aanvragen",
    "passwordMinLength": "Wachtwoord moet minimaal 6 tekens zijn",
    "passwordsMustMatch": "Wachtwoorden komen niet overeen",
    "emailAddress": "E-mailadres",
    "dontHaveAccount": "Nog geen account?",
    "signUp": "Registreren",
    "businessSignUp": "Bedrijf registreren",
    "joinAsBusinessTitle": "Meedoen als bedrijf",
    "freeTrialOffer": "Start direct met je vermelding",
    "accountInformation": "Accountgegevens",
    "fullName": "Volledige naam",
    "email": "E-mail",
    "businessInformation": "Bedrijfsinformatie",
    "businessName": "Bedrijfsnaam",
    "description": "Beschrijving",
    "tellUsAbout": "Vertel ons over je bedrijf...",
    "continue": "Doorgaan",
    "fullNamePlaceholder": "Jan Jansen",
    "passwordPlaceholder": "Maak een sterk wachtwoord",
    "businessNamePlaceholder": "Je bedrijfsnaam",
    "stepOf": "Stap {{step}} van {{total}}",
    "allFieldsRequired": "Alle velden zijn verplicht",
    "businessNameDescRequired": "Bedrijfsnaam en beschrijving zijn verplicht",
    "fillAllRequired": "Vul alle verplichte velden in",
    "specifyCategoryOther": "Geef een categorie op",
    "selectPlanRequired": "Kies een abonnement",
    "registrationFailed": "Registratie mislukt. Probeer het opnieuw.",
    "emailAlreadyRegistered": "Dit e-mailadres is al geregistreerd.",
    "contactLocation": "Contact & Locatie",
    "categoryLabel": "Categorie",
    "selectCategory": "Kies categorie",
    "specifyCategory": "Categorie opgeven",
    "cityLabel": "Stad",
    "businessAddress": "Bedrijfsadres",
    "phoneNumber": "Telefoonnummer",
    "businessEmailLabel": "Bedrijfse-mail",
    "websiteLabel": "Website",
    "openingHoursLabel": "Openingstijden",
    "chooseYourPlan": "Kies je plan",
    "perMonth": "maand",
    "plusIVA": "BTW inbegrepen",
    "bestValue": "Beste waarde",
    "selected": "Geselecteerd",
    "freeTrialTitle": "Direct publiceren",
    "freeTrialDesc": "Betaal één keer — je vermelding gaat live zodra de betaling is bevestigd. Alle prijzen incl. 21% BTW. Op elk moment opzegbaar.",
    "settingUp": "Instellen...",
    "proceedToPayment": "Naar betaling",
    "alreadyHaveAccount": "Al een account?",
    "timeTo": "tot",
    "closed": "Gesloten",
    "dayMonday": "Maandag",
    "dayTuesday": "Dinsdag",
    "dayWednesday": "Woensdag",
    "dayThursday": "Donderdag",
    "dayFriday": "Vrijdag",
    "daySaturday": "Zaterdag",
    "daySunday": "Zondag",
    "plan6months": "6 maanden",
    "plan12months": "Best Setup / Volledige Toegang",
    "featured": "Uitgelicht",
    "searchPlaceholder": "Bedrijven zoeken...",
    "logout": "Uitloggen",
    "all": "Alles",
    "pendingTab": "In behandeling",
    "callNow": "Nu bellen",
    "emailButton": "E-mail",
    "openingHours": "Openingstijden",
    "pendingApprovalTitle": "Wacht op goedkeuring",
    "pendingApprovalDesc": "Je bedrijf wordt beoordeeld door ons team",
    "trialDaysRemaining": "{{days}} dag(en) resterend",
    "businessVisible": "Je bedrijf is zichtbaar voor gebruikers",
    "subscriptionActive": "Abonnement actief",
    "subscriptionExpired": "Abonnement verlopen",
    "activeFilters": "Actieve filters",
    "noBusinessesFound": "Geen bedrijven gevonden.",
    "tryDifferentFilters": "Probeer andere filters of zoektermen.",
    "clearFilters": "Filters wissen",
    "businessFound": "Bedrijf gevonden",
    "businessesFound": "Bedrijven gevonden",
    "filters": "Filters",
    "resetAll": "Alles resetten",
    "applyFilters": "Filters toepassen",
    "settings": "Instellingen",
    "language": "Taal",
    "notifications": "Meldingen",
    "noEventsYet": "Nog geen evenementen",
    "browseBusinesses": "Bedrijven bekijken",
    "noOffersYet": "Nog geen aanbiedingen",
    "noFavoritesYet": "Nog geen favorieten",
    "discoverBusinesses": "Bedrijven ontdekken",
    "save": "Opslaan",
    "saved": "Opgeslagen",
    "cancel": "Annuleren",
    "consentText": "Ik ga akkoord met de",
    "consentAnd": "en",
    "termsAndConditions": "Algemene Voorwaarden",
    "privacyPolicyTitle": "Privacybeleid",
    "back": "Terug",
    "submit": "Versturen",
    "or": "of",
    "loading": "Laden...",
    "error": "Fout",
    "success": "Gelukt",
    "goBack": "Terug",
    "goHome": "Startpagina",
    "about": "Over",
    "share": "Delen",
    "copyLink": "Link kopiëren",
    "linkCopied": "Gekopieerd!",
    "shareMore": "Meer",
    "shareDefaultText": "Bekijk deze vermelding op Find-2-Day!",
    "reviews": "Beoordelingen",
    "writeReview": "Beoordeling schrijven",
    "noReviewsYet": "Nog geen beoordelingen. Wees de eerste!",
    "loginToReview": "Log in om een beoordeling te schrijven",
    "favourite": "Opslaan",
    "favourited": "Opgeslagen",
    "resetFilters": "Filters resetten",
    "offers": "Aanbiedingen",
    "activeOffers": "actieve aanbiedingen",
    "upcomingEvents": "komende evenementen",
    "daysLeft": "dagen resterend",
    "manageSubscription": "Abonnement beheren",
    "onboardingTitle": "Welkom bij Find-2-Day!",
    "onboardingStep1Title": "Lokale vermeldingen ontdekken",
    "onboardingStep1Desc": "Blader door bedrijven, goede doelen, evenementen en aanbiedingen bij jou in de buurt.",
    "onboardingStep2Title": "Favorieten opslaan",
    "onboardingStep2Desc": "Tik op het hart om vermeldingen op te slaan.",
    "onboardingStep3Title": "Meldingen ontvangen",
    "onboardingStep3Desc": "Tik op 'Meldingen' bij een vermelding om updates te ontvangen.",
    "onboardingGotIt": "Begrepen!",
    "onboardingNext": "Volgende",
    "onboardingSkip": "Overslaan",
    "locationPicker": {
      "title": "Krijg meldingen voor jouw omgeving",
      "intro": "Kies jouw gemeente in Almería zodat we je evenementen, aanbiedingen en veiligheidsmeldingen in de buurt kunnen sturen.",
      "homeTownLabel": "Jouw gemeente of dorp",
      "searchPlaceholder": "Zoek Almería gemeentes…",
      "noTowns": "Geen gemeentes gevonden.",
      "nearbyLabel": "Meld ook gemeentes in de buurt",
      "nearbyHint": "Binnen {{km}} km van jouw gemeente. Aanpasbaar.",
      "radiusAria": "Nabij-straal in kilometers",
      "regionLabel": "Meld alles in heel Almería",
      "regionHint": "Provinciebrede evenementen, grote aanbiedingen en veiligheidsmeldingen.",
      "followedTownsLabel": "Volg ook deze gemeentes (optioneel)",
      "followedTownsHint": "Selecteer extra gemeentes naast jouw thuisbasis.",
      "followedTownsAddPlaceholder": "Voeg gemeente toe…",
      "removeTown": "Verwijderen",
      "skip": "Nu niet",
      "save": "Mijn gebied opslaan",
      "saving": "Opslaan…"
    },
    "categoryFood": "Eten & Drinken",
    "categoryMusic": "Muziek & Nachtleven",
    "categoryShopping": "Winkelen",
    "categoryHealthWellness": "Gezondheid & Welzijn",
    "categoryEvents": "Evenementen & Entertainment",
    "categoryEducation": "Onderwijs",
    "categoryHomeServices": "Thuisservices",
    "categoryTravel": "Reizen & Toerisme",
    "categoryBeautySpa": "Beauty & Spa",
    "categorySports": "Sport & Fitness",
    "categoryArts": "Kunst & Cultuur",
    "categoryProfessional": "Zakelijke diensten",
    "categoryAutomotive": "Automotive",
    "categoryTechnology": "Technologie",
    "categoryVets": "Dierenartsen",
    "categoryVolunteerWork": "Vrijwilligerswerk",
    "categoryJobs": "Vacatures",
    "categoryCommunityHelp": "Gemeenschapshulp",
    "categoryCommunity": "Gemeenschap",
    "categoryOther": "Overig",
    "pwaInstallTitle": "Find-2-Day installeren",
    "pwaInstallBtn": "Installeren",
    "whatsNew_title": "Wat is nieuw",
    "whatsNew_item1": "Directe meldingen van je favoriete bedrijven — nieuwe evenementen, aanbiedingen en meer",
    "whatsNew_item2": "Werkt op alle apparaten — pushmeldingen plus e-mail als alternatief",
    "whatsNew_cta": "Meldingen voor evenementen & aanbiedingen",

    "marketplace": {
      "tabSell": "Verkopen", "tabWanted": "Gezocht", "tabSwap": "Ruilen", "tabFree": "Gratis",
      "hintMarketTitle": "Kopen, verkopen, ruilen of weggeven",
      "swapTitle": "SWAP-2-DAY", "swapSubtitle": "Wat heb je? Waarvoor zou je het ruilen?",
      "swapLabel": "Ruilen", "orSwap": "OF RUILEN"
    },
    "swap": {
      "moneyNone": "Geen", "moneyBtoA": "Bieder betaalt eigenaar €{n}", "moneyAtoB": "Eigenaar betaalt bieder €{n}",
      "ownerProvides": "Eigenaar geeft", "offererProvides": "Bieder geeft", "money": "Extra geld",
      "negotiation": "Ruilonderhandeling", "youAre": "Jij bent de", "owner": "eigenaar van de advertentie", "offerer": "persoon die het bod doet",
      "agreed": "RUIL OVEREENGEKOMEN", "agreedAt": "Overeengekomen op", "finalTerms": "Definitief overeengekomen voorwaarden", "currentTerms": "Huidige voorwaarden",
      "confirmed": "bevestigd ✓", "notConfirmed": "nog niet", "ownerLabel": "Eigenaar", "offererLabel": "Bieder",
      "iAgree": "Ik ga akkoord met deze ruil", "youConfirmed": "Je hebt bevestigd – wachten op de andere persoon",
      "counter": "Tegenbod", "decline": "Weigeren", "withdraw": "Mijn bod intrekken", "cancel": "Deze onderhandeling annuleren",
      "history": "Bodgeschiedenis", "makeCounter": "Een tegenbod doen", "commaSep": "gescheiden door komma's",
      "moneyAmount": "Geld (€)", "moneyDir": "Betaalrichting", "dirNone": "Geen geld", "dirBtoA": "Bieder betaalt eigenaar", "dirAtoB": "Eigenaar betaalt bieder",
      "notePlaceholder": "Optionele notitie…", "sendCounter": "Tegenbod versturen", "backToMarket": "Terug naar Marktplaats",
      "loadFail": "Deze ruil kon niet worden geladen.", "actionFail": "Actie mislukt.",
      "ownerGives": "De eigenaar geeft", "describeYours": "Beschrijf wat je in ruil zou geven (je kunt ook geld toevoegen).",
      "itemsPlaceholder": "bijv. Grasmaaier, Trimmer (gescheiden door komma's)", "sendOffer": "Ruilbod versturen", "createFail": "Bod kon niet worden verzonden.",
      "errName": "Voer je naam in.", "errEmail": "Voer een geldig e-mailadres in.", "errItems": "Beschrijf ten minste één artikel dat je aanbiedt."
    },
    "classifieds": {
      "listingType": "Advertentietype", "typeSellOnly": "Alleen verkopen", "typeSwapOnly": "Alleen ruilen", "typeSellOrSwap": "Verkopen of ruilen", "typeFree": "Gratis", "typeWanted": "Gezocht",
      "swapWantedTitle": "Wat wil je in ruil?", "swapAddOwn": "Voeg je eigen toe…", "openToOffers": "Open voor aanbiedingen",
      "swapPrefsHint": "Dit zijn alleen voorkeuren – anderen mogen ook iets anders aanbieden.", "sellSwapPriceHint": "Kopers kunnen tegen deze prijs kopen OF een ruilbod doen.",
      "errSellSwapPrice": "Voer een verkoopprijs in voor een 'Verkopen of ruilen'-advertentie",
      "buyFor": "Kopen voor", "swapWantedShort": "Ruil gezocht", "swapOpenAny": "open voor ideeën", "otherOffersConsidered": "Andere aanbiedingen worden overwogen",
      "contactToBuy": "Contact om te kopen", "makeSwapOffer": "Een ruilbod doen", "statusSwapped": "Geruild!",
      "swappedNote": "Geruilde advertenties zijn verborgen in de zoekresultaten. Jouw record blijft voor jou bewaard.",
      "editTypePrice": "Advertentietype / prijs wijzigen (bijv. dit artikel ook verkopen)", "editSwapNote": "Kopers zien '€… OF RUILEN' en kunnen een ruilbod doen. Je foto's, beschrijving en advertentie-ID blijven hetzelfde.",
      "offersReceived": "Ontvangen ruilbiedingen", "noOffersYet": "Nog geen ruilbiedingen.", "errSave": "Wijzigingen konden niet worden opgeslagen.",
      "title": "Verkopen / Verloren / Gevonden",
      "sellTab": "Verkopen",
      "hintCardTitle": "Waar moet ik dit plaatsen?",
      "hintCardSell": "Een artikel verkopen",
      "hintCardSellDesc": "Gebruik het tabblad Verkopen",
      "hintCardLostFound": "Iets verloren of gevonden",
      "hintCardLostFoundDesc": "Gebruik het tabblad Verloren & Gevonden",
      "hintCardPetSafety": "Huisdier kwijt of veiligheidsprobleem",
      "hintCardPetSafetyDesc": "Gebruik de Community-veiligheidshub",
      "searchPlaceholder": "Artikelen zoeken...",
      "postItem": "Artikel plaatsen",
      "noItems": "Geen artikelen gevonden",
      "tryDifferent": "Probeer andere zoektermen of filters",
      "beFirst": "Wees de eerste om iets te verkopen!",
      "itemFound": "artikel",
      "itemsFound": "artikelen",
      "negotiable": "Bespreekbaar",
      "sold": "Verkocht",
      "description": "Beschrijving",
      "contactSeller": "Verkoper contacteren",
      "expiresOn": "Deze advertentie verloopt op",
      "ownerActions": "Je hebt eigenaarstoegang tot deze advertentie.",
      "markSold": "Als verkocht markeren",
      "delete": "Verwijderen",
      "deleteListing": "Advertentie verwijderen",
      "confirmSold": "Als verkocht markeren?",
      "confirmDelete": "Advertentie verwijderen?",
      "confirmDeleteDesc": "Deze advertentie wordt permanent verwijderd.",
      "yesSold": "Ja, verkocht",
      "yesDelete": "Ja, verwijderen",
      "posted": "Artikel geplaatst!",
      "postedDesc": "Je advertentie is nu actief. Na 30 dagen verloopt deze automatisch.",
      "saveLink": "Bewaar deze link om je advertentie te beheren:",
      "viewListing": "Advertentie bekijken",
      "browseMore": "Meer bekijken",
      "photos": "Foto's",
      "itemTitle": "Titel",
      "titlePlaceholder": "Wat verkoop je?",
      "category": "Categorie",
      "price": "Prijs",
      "optional": "optioneel",
      "priceHint": "Leeg laten voor \"Bespreekbaar\"",
      "descLabel": "Beschrijving",
      "descPlaceholder": "Beschrijf het artikel, staat, kenmerken...",
      "location": "Locatie",
      "locationPlaceholder": "bijv. Almería Centro, Retamar...",
      "contactInfo": "Je contactgegevens",
      "yourName": "Naam",
      "namePlaceholder": "Je naam",
      "yourEmail": "E-mail",
      "emailPlaceholder": "je@email.nl",
      "yourPhone": "Telefoon",
      "addPhoto": "Toevoegen",
      "maxPhotos": "Maximaal 6 foto's toegestaan",
      "posting": "Plaatsen...",
      "postForFree": "Gratis plaatsen",
      "autoExpire": "Advertenties verlopen automatisch na 30 dagen",
      "cat": {
        "Tools": "Gereedschap",
        "Furniture": "Meubels",
        "Cars & Vehicles": "Auto's & Voertuigen",
        "Electronics": "Elektronica",
        "Property": "Vastgoed",
        "Clothing & Fashion": "Kleding & Mode",
        "Home & Garden": "Huis & Tuin",
        "Sports & Leisure": "Sport & Vrije Tijd",
        "Baby & Kids": "Baby & Kinderen",
        "General": "Algemeen"
      },
      "statusAvailable": "Beschikbaar",
      "statusPending": "In afwachting van ophaling",
      "statusSold": "Verkocht",
      "changeStatus": "Status wijzigen",
      "soldAutoRemove": "Verkochte items worden na 3 dagen automatisch verwijderd.",
      "errorStatus": "Status kon niet worden bijgewerkt.",
      "emailSent": "Beheerlink naar je e-mail verzonden",
      "emailSentDesc": "Controleer je inbox voor de link om te bewerken of te verwijderen.",
      "manageHelp": "Met je beheerlink kun je:",
      "manageEdit": "Advertentiedetails bewerken",
      "managePending": "Status instellen op 'In afwachting van ophaling'",
      "manageSold": "Markeren als Verkocht (verborgen na 3 dagen)",
      "manageDelete": "De advertentie verwijderen",
      "manageListing": "Advertentie beheren",
      "manageYourListing": "Je advertentie beheren",
      "resendLink": "Beheerlink kwijt?",
      "resendTitle": "Je beheerlinks ophalen",
      "resendDesc": "Vul het e-mailadres in dat je bij het plaatsen hebt gebruikt.",
      "resendEmailPlaceholder": "je@email.nl",
      "resendBtn": "Versturen",
      "resendSent": "Controleer je e-mail!",
      "resendSentDesc": "Als er actieve advertenties zijn, hebben we de beheerlinks verstuurd.",
      "resendErrEmail": "Vul een geldig e-mailadres in",
      "resendError": "Er ging iets mis. Probeer opnieuw."
    },
    "nearestMe": {
      "button": "Dichtbij mij",
      "notSupported": "Geolocatie wordt niet ondersteund door je browser",
      "denied": "Locatietoegang geweigerd. Je kunt zoeken op stad.",
      "error": "Locatie kon niet worden bepaald. Probeer opnieuw.",
      "townPlaceholder": "Voer een plaats in, bijv. Lyon, Frankrijk",
      "useTown": "Plaats gebruiken",
      "townNotFound": "Plaats niet gevonden. Probeer een grotere plaats in de buurt of voeg het land toe."
    },
    "lostFound": {
      "title": "Verloren & Gevonden",
      "searchPlaceholder": "Verloren & gevonden zoeken...",
      "postItem": "Verloren/Gevonden item melden",
      "noItems": "Geen items gevonden",
      "beFirst": "Meld een verloren of gevonden item.",
      "lost": "Verloren", "found": "Gevonden", "lostOn": "Verloren", "foundOn": "Gevonden",
      "resolved": "Opgelost", "markResolved": "Markeren als opgelost", "contactPerson": "Contact",
      "typeLabel": "Is het item verloren of gevonden?",
      "iLostSomething": "Ik ben iets verloren", "iFoundSomething": "Ik heb iets gevonden",
      "itemTitle": "Wat is verloren/gevonden?",
      "titlePlaceholder": "bijv. Klein bruin hondje, autosleutels...",
      "category": "Categorie", "dateLost": "Datum verloren", "dateFound": "Datum gevonden",
      "descPlaceholder": "Beschrijf het item, waar het verloren/gevonden is...",
      "locationLabel": "Gebied / Locatie", "locationPlaceholder": "bijv. Almería Centro, Retamar...",
      "posted": "Gemeld!", "postedDesc": "Je melding is actief. Verloopt na 30 dagen.",
      "viewItem": "Item bekijken", "browseMore": "Meer bekijken", "postForFree": "Gratis melden",
      "cat": { "Pets": "Huisdieren", "Keys": "Sleutels", "Wallets/Bags": "Portemonnees/Tassen", "Documents/ID": "Documenten/ID", "Phones/Electronics": "Telefoons/Elektronica", "Other": "Overig" }
    },
    "savedSearch": {
      "setAlert": "Zoekmelding instellen",
      "title": "Zoekmelding",
      "desc": "Ontvang een melding wanneer nieuwe artikelen overeenkomen met je zoekopdracht.",
      "queryPlaceholder": "bijv. bank, fiets, iPhone...",
      "anyCategory": "Elke categorie",
      "emailPlaceholder": "Je e-mail voor meldingen",
      "save": "Melding opslaan",
      "saving": "Opslaan...",
      "saved": "Melding opgeslagen!",
      "savedDesc": "We e-mailen je wanneer er nieuwe artikelen zijn die matchen.",
      "errQuery": "Zoekterm moet minimaal 2 tekens zijn",
      "errEmail": "Vul een geldig e-mailadres in",
      "errSave": "Opslaan mislukt",
      "unsubscribed": "Afgemeld",
      "unsubscribedDesc": "Je ontvangt geen meldingen meer voor deze zoekopdracht.",
      "unsubscribeError": "Afmelden mislukt",
      "unsubscribeErrorDesc": "Deze link is mogelijk verlopen.",
      "backToClassifieds": "Verkopen / Verloren / Gevonden bekijken"
    },

    "legal": "Juridisch",
    "nearbyDeals": "Aanbiedingen & Promoties in de buurt",
    "nearbyDealsDesc": "Ontvang af en toe gesponsorde aanbiedingen van bedrijven die je niet volgt",
    "enableNotificationsFirst": "Volg een bedrijf of schakel meldingen in om je voorkeuren te beheren.",
    "account": "Account",
    "support": "Ondersteuning",
    "privacySecurity": "Privacy & Beveiliging",
    "helpCenter": "Hulpcentrum",
    "aboutApp": "Over Find-2-Day",
    "termsOfService": "Algemene Voorwaarden",
    "privacyPolicy": "Privacybeleid",
    "cookiePolicy": "Cookiebeleid",
    "disputePolicy": "Geschillenbeleid",
    "admin": "Admin",
    "terms": "Voorwaarden",
    "privacy": "Privacy",
    "cookies": "Cookies",
    "deleteData": "Mijn gegevens verwijderen",
    "deleteAccountTitle": "Account & gegevens verwijderen",
    "whatWillBeDeleted": "Wat wordt verwijderd:",
    "deleteItem1": "Je gebruikersaccount en inloggegevens",
    "deleteItem2": "Bedrijfsvermelding en foto's (indien van toepassing)",
    "deleteItem3": "Favorieten en opgeslagen voorkeuren",
    "deleteItem4": "Alle bijbehorende persoonlijke gegevens",
    "reasonOptional": "Reden (optioneel)",
    "reasonPlaceholder": "Vertel ons waarom je weggaat...",
    "requestDeletion": "Accountverwijdering aanvragen",
    "emailDirectly": "Je kunt je verzoek ook rechtstreeks per e-mail sturen naar:",
    "requestReceived": "Verzoek ontvangen",
    "requestReceivedDesc": "Je verwijderingsverzoek is ingediend. We verwerken het binnen 30 dagen.",
    "contactDirectly": "Je kunt ons ook rechtstreeks bereiken via",
    "changePasswordTitle": "Wachtwoord wijzigen",
    "memberSince": "Lid sinds",
    "businessAccount": "Zakelijk account",
    "regularAccount": "Gebruikersaccount",
    "businessDashboard": "Bedrijfsdashboard",
    "businessNotFound": "Bedrijfsprofiel niet gevonden",
    "listingUnavailable": "Deze bedrijfsvermelding is niet meer beschikbaar.",
    "duplicateViewBtn": "Vermelding bekijken",
    "claimRetiredTitle": "Claimen is niet meer beschikbaar",
    "claimRetiredBody": "Find-2-Day werkt nu via zelfregistratie. Heb je een bedrijf? Maak gewoon je eigen vermelding — een bestaand record claimen is niet nodig.",
    "claimRetiredRegister": "Registreer je bedrijf",
    "backToHome": "Terug naar start",
    "townCityLabel": "Plaats / Stad", "townCityPlaceholder": "bijv. Madrid", "countryLabel": "Land", "countrySelect": "Kies een land", "regionLabel": "Regio / Provincie", "regionPlaceholder": "bijv. Andalusië", "localAreaLabel": "Buurt / Wijk", "postcodeLabel": "Postcode", "regionLabel2": "Regio / Staat", "provinceLabel": "Provincie", "provincePlaceholder": "bijv. Almería", "mapView": "Kaart", "mapNoCoords": "Geen van deze bedrijven heeft nog een kaartlocatie. Schakel naar lijstweergave om alle resultaten te zien.", "directionsBtn": "Route", "filterCountry": "Land", "filterRegion": "Regio / Staat", "filterProvince": "Provincie", "filterTown": "Plaats / Stad", "allCountries": "Alle landen", "allRegions": "Alle regio's", "allProvinces": "Alle provincies", "allTowns": "Alle plaatsen", "locationFilterLabel": "Locatie",
    "faqTitle": "Veelgestelde vragen",
    "faq1q": "Hoe registreer ik mijn bedrijf?",
    "faq1a": "Klik op 'Meedoen als bedrijf' en volg het 5-stappen registratieproces.",
    "faq2q": "Hoe werkt de facturering?",
    "faq2a": "Alle plannen starten direct na betaling — geen gratis proefperiode.",
    "faq3q": "Wanneer wordt mijn bedrijf zichtbaar?",
    "faq3a": "Na goedkeuring door de beheerder, meestal binnen 24-48 uur.",
    "contactUs": "Neem contact op",
    "trialPeriod": "Facturering",
    "subscriptionPlans": "Abonnementen",
    "allRightsReserved": "Alle rechten voorbehouden.",
    "aboutDescription": "Find-2-Day is je lokale ontdekkingsplatform. Vind restaurants, evenementen, activiteiten en aanbiedingen bij jou in de buurt.",

    "findAmazing": "Vind geweldige ervaringen bij jou in de buurt",
    "eventsWillAppear": "Evenementen van lokale bedrijven verschijnen hier binnenkort!",
    "offersWillAppear": "Kom binnenkort terug voor geweldige aanbiedingen!",
    "startExploring": "Begin bedrijven te verkennen en sla je favorieten op!",

    "changePassword": "Wachtwoord wijzigen",
    "backToHome": "Naar startpagina",
    "days": "dagen",
    "enableNotifications": "Meldingen inschakelen",
    "notificationSettings": "Meldinginstellingen",
    "visitWebsite": "Website bezoeken",
    "featuresAmenities": "Voorzieningen & Aanbod",
    "noFeaturesYet": "Nog geen functies of diensten toegevoegd.",
    "addFeatures": "Functies & Diensten toevoegen",
    "featureEditHint": "Klik op items om ze toe te voegen of te verwijderen. Sla op wanneer klaar.",
    "reviewCount": "beoordelingen",
    "reviewBy": "Beoordeling door",
    "ratingRequired": "Geef een beoordeling",
    "reviewTextMin": "Minimaal 10 tekens",
    "reviewTextMax": "Maximaal 500 tekens",
    "charsRemaining": "tekens resterend",
    "submittingReview": "Wordt verzonden...",
    "reviewSubmitted": "Beoordeling ingediend!",
    "alreadyReviewed": "Je hebt al een beoordeling geschreven",
    "removeFavorite": "Uit favorieten verwijderen",
    "reportListing": "Vermelding melden",
    "reportReview": "Beoordeling melden",
    "loginToReport": "Inloggen om te melden",
    "loginToClaim": "Inloggen om te claimen",
    "signInToClaim": "Inloggen om te claimen",
    "claimThisBusiness": "Bedrijf claimen",
    "claimNowBtn": "Nu claimen",
    "claimBanner": "Is dit jouw bedrijf?",
    "claimTopBannerText": "Claim deze vermelding om te beheren",
    "claimToUnlock": "Claim de vermelding om te beheren",
    "claimSubmitted": "Claim ingediend",
    "claimSubmittedDesc": "We beoordelen je verzoek en nemen contact op.",
    "claimAutoApproved": "Automatisch goedgekeurd",
    "claimAutoApprovedDesc": "Je claim is goedgekeurd!",
    "claimAlreadyClaimed": "Al geclaimd",
    "claimAlreadyPending": "Claim wordt beoordeeld",
    "claimStatusApproved": "Goedgekeurd",
    "claimStatusPending": "Wordt beoordeeld",
    "claimStatusRejected": "Afgewezen",
    "claimError": "Fout bij claimen",
    "alreadyListedClaim": "Dit bedrijf is al geregistreerd",
    "unclaimedListing": "Niet-geclaimde vermelding",
    "unclaimedContactNotice": "Contactgegevens mogelijk niet actueel",
    "verifiedOwner": "Geverifieerde eigenaar",
    "verifyingEmail": "E-mail wordt geverifieerd...",
    "verifySuccessDesc": "Je e-mail is geverifieerd.",
    "resetPasswordError": "Fout bij wachtwoord resetten",
    "token": "Token",
    "expirestoday": "Verloopt vandaag",
    "groupSizesWelcome": "Groepsgroottes welkom",
    "firstFollowBoost": "Volg bedrijven voor updates!",
    "followEmptyTitle": "Geen gevolgde bedrijven",
    "followEmptyDesc": "Volg bedrijven om updates te ontvangen",
    "followEmptyCta": "Bedrijven ontdekken",
    "notifIOSShort": "iOS: Voeg toe aan beginscherm",
    "notifAndroidShort": "Android: Installeren",
    "notifGenericShort": "Meldingen inschakelen",
    "disputePolicyTitle": "Geschillen- en meldingsbeleid",
    "charity.applyForListing": "Gratis aanvragen voor gemeenschaps- of liefdadigheidsvermelding",
    "charity.charityBadge": "Gemeenschap & liefdadigheid",
    "planBasic": "Basis", "perYear": "/jaar", "per6Months": "/6 mnd", "per12Months": "/12 mnd",
    "ivaIncluded": "BTW inbegrepen",
    "basicMonthlyHint": "Founding Business Aanbieding · 12 maanden GRATIS — geen kaart nodig",
    "basicRestrictions": "Alleen vermelding + foto's + contact. Geen evenementen, aanbiedingen of geboosted promoties.",
    "upgradeFromBasicTitle": "Ontgrendel evenementen, aanbiedingen en functies",
    "upgradeFromBasicDesc": "Alle bedrijven zijn momenteel 12 maanden gratis onder de Founding Business Aanbieding — evenementen, aanbiedingen, geboostte promoties en alle vermeldingsfuncties zijn inbegrepen zonder kosten tijdens de founding-periode.",
    "earnUpToPerSignup": "Verdien 50% van alles wat je verwezen bedrijven betalen",
    "minPayoutHint": "Minimum €{{amount}} saldo nodig voor uitbetaling.",
    "payoutProgress": "Uitbetalingsvoortgang",
    "balanceLabel": "Saldo",
    "eligibleForPayout": "Klaar voor uitbetaling",
    "notYetEligible": "Nog niet klaar — blijf zo doorgaan!",
    "pendingMaturing": "In afwachting (rijpend)",
    "pendingMaturingDesc": "Commissies in de {{days}}-daagse clearingperiode.",
    "availableForPayout": "Beschikbaar voor uitbetaling",
    "availableForPayoutDesc": "{{days}} dagen verstreken en klaar om uitbetaald te worden.",
    "clearanceTooltip": "Commissies worden {{days}} dagen na betaling beschikbaar, in lijn met het chargeback-venster van onze betalingsverwerker. Je ontvangt het volledige bedrag — het duurt alleen {{days}} dagen om te rijpen.",
    "maturesInDays": "Rijpt over {{count}} dag",
    "maturesInDays_plural": "Rijpt over {{count}} dagen",
    "availableNow": "Beschikbaar",
    "min": "min",
    "payoutCycleNote": "Uitbetalingen worden na een {{days}}-daagse clearingperiode (terugbetalingsvenster) beoordeeld en maandelijks door het admin-team verwerkt.",
    "calendar": { "addToCalendar": "Toevoegen aan agenda", "icsDownload": "Apple / Outlook (.ics)", "icsHint": "Universeel agendabestand", "googleCalendar": "Google Agenda", "googleHint": "Opent in nieuw tabblad" },
    "previewYourListing": "Bekijk je vermelding",
    "previewYourListingHint": "Zie precies hoe je vermelding eruitziet voordat je betaalt. Opent in nieuw tabblad — niets wordt opgeslagen.",
    "waiverTitle": "Onmiddellijke start van de dienst",
    "waiverLabel": "Ik ga ermee akkoord dat mijn bedrijfsvermelding direct live gaat en ik doe afstand van mijn 14-daagse herroepingsrecht volgens het EU-consumentenrecht.",
    "waiverRequired": "U moet afstand doen van het herroepingsrecht om door te gaan.",
    "waiverLegalNote": "In overeenstemming met EU-richtlijn 2011/83/EU, art. 16 lid m (digitale inhoud / onmiddellijk geleverde diensten).",
    "emergency": {
      "title": "Noodnummers", "subtitle": "Regio Almería — tik om te bellen",
      "disclaimerTitle": "Bij levensbedreigende nood:", "disclaimerBody": "Deze pagina is informatief.",
      "callNow": "bel nu 112", "tapToCall": "Tik om te bellen",
      "footerNote": "Laatst gecontroleerd in februari 2026.",
      "euEmergency": "Nood (EU)", "euEmergencyDesc": "Eén nummer voor politie, ambulance en brandweer in de EU",
      "nationalPolice": "Policía Nacional", "nationalPoliceDesc": "Nationale politie",
      "guardiaCivil": "Guardia Civil", "guardiaCivilDesc": "Landelijke gebieden, wegen, grenzen",
      "localPolice": "Policía Local", "localPoliceDesc": "Lokale zaken, parkeren",
      "medical": "Medische spoed", "medicalDesc": "Ambulance en spoedzorg",
      "fire": "Brandweer", "fireDesc": "Branden, reddingen",
      "dvSupport": "Huiselijk geweld", "dvSupportDesc": "24/7 gratis en vertrouwelijk",
      "torrecardenas": "Hospital Torrecárdenas", "torrecardenasDesc": "Belangrijkste openbare ziekenhuis Almería",
      "ukConsulate": "Brits consulaat (Málaga)", "ukConsulateDesc": "Ondersteuning voor Britse burgers",
      "ieConsulate": "Ierse ambassade (Madrid)", "ieConsulateDesc": "Ondersteuning voor Ierse burgers",
      "cat": { "primary": "Nood", "police": "Politie", "medical": "Medisch", "fire": "Brand", "support": "Hulp", "consulate": "Consulaat" }
    },
    "holidays": {
      "title": "Feestdagen", "subtitle": "Spanje & Andalusië — 2026",
      "nextHoliday": "Volgende feestdag", "today": "Vandaag", "tomorrow": "Morgen", "inNDays": "over {{count}} dagen",
      "footerNote": "Data kunnen per gemeente verschillen.",
      "scope": { "national": "Nationaal", "andalusia": "Andalusië", "almeria": "Almería" },
      "month": { "january": "januari", "february": "februari", "march": "maart", "april": "april", "may": "mei", "june": "juni", "july": "juli", "august": "augustus", "september": "september", "october": "oktober", "november": "november", "december": "december" },
      "newYear": "Nieuwjaarsdag", "epiphany": "Driekoningen", "andalusiaDay": "Dag van Andalusië",
      "maundyThursday": "Witte Donderdag", "goodFriday": "Goede Vrijdag", "labourDay": "Dag van de Arbeid",
      "sanJuan": "San Juan (Almería)", "assumption": "Maria-Tenhemelopneming", "virgenDelMar": "Virgen del Mar (Almería)",
      "nationalDay": "Spaanse Nationale Feestdag", "allSaints": "Allerheiligen",
      "constitutionDay": "Dag van de Grondwet", "immaculate": "Onbevlekte Ontvangenis", "christmas": "Kerstmis"
    },

    // Added Feb 2026 — auth, inbox, data deletion, trial, safety bulletin, guide
    "common": { "back": "Terug", "loading": "Laden…", "optional": "optioneel" },
    "auth": {
      "pwStrongPlaceholder": "Maak een sterk wachtwoord",
      "pwReenter": "Wachtwoord opnieuw invoeren",
      "pwReenterFull": "Voer je wachtwoord opnieuw in",
      "pwMin6": "Minstens 6 tekens",
      "pwConfirm": "Wachtwoord bevestigen"
    },
    "businessAuth": {
      "loginTitle": "Bedrijfslogin",
      "loginSubtitle": "Log in om je bedrijfsvermelding te beheren",
      "signIn": "Inloggen",
      "signingIn": "Inloggen…",
      "noAccount": "Nog geen account?",
      "registerHere": "Registreer hier",
      "backHome": "Terug naar home",
      "errInvalidType": "Ongeldig accounttype. Gebruik een bedrijfsaccount.",
      "errLoginFailed": "Inloggen mislukt. Probeer opnieuw.",
      "registerTitle": "Registreer je bedrijf",
      "step1": "Stap 1: maak je account aan",
      "step2": "Stap 2: bedrijfsgegevens",
      "phName": "Naam van je bedrijf",
      "phCategory": "Categorie selecteren",
      "phAddress": "Straatadres"
    },
    "helperAuth": {
      "loginTitle": "Partner-login",
      "loginSubtitle": "Log in om je verwijzingen en commissies te zien"
    },
    "inbox": {
      "title": "Meldingen",
      "typeEvent": "Evenement", "typeOffer": "Aanbieding", "typeSystem": "Systeem", "typeSafety": "Veiligheid",
      "justNow": "zojuist", "minsAgo": "{{n}} min geleden", "hoursAgo": "{{n}} u geleden", "daysAgo": "{{n}} d geleden",
      "unreadCount": "{{n}} ongelezen", "sponsoredCount": "{{n}} gesponsord",
      "settingsTitle": "Meldingsinstellingen", "markAllRead": "Alles als gelezen markeren",
      "errLoad": "Meldingen konden niet worden geladen", "errMarkAll": "Markeren als gelezen mislukt",
      "emptyEnableTitle": "Meldingen inschakelen",
      "emptyEnableBody": "Schakel meldingen in vanaf een bedrijfspagina of in Instellingen om hier meldingen te ontvangen.",
      "openSettings": "Instellingen openen",
      "emptyTitle": "Nog geen meldingen",
      "emptyBody": "Wanneer bedrijven die je volgt nieuwe evenementen of aanbiedingen plaatsen, verschijnen ze hier.",
      "sponsored": "Gesponsord", "sponsoredTitle": "Dit is een gepromote aanbieding",
      "unread": "Ongelezen", "fallbackTitle": "Melding"
    },
    "dataDeletion": {
      "title": "Verwijder je account",
      "subtitle": "Deze actie is permanent en kan niet ongedaan worden gemaakt.",
      "doneTitle": "Account verwijderd",
      "doneBody": "Je account is permanent verwijderd. Openbare recensies zijn geanonimiseerd. Je kunt je altijd opnieuw aanmelden met een nieuw account.",
      "doneSubCancelled": "Je actieve abonnement is geannuleerd.",
      "doneUnclaimed": "Je bedrijfsvermelding is teruggezet naar 'niet-geclaimd' zodat de community hem nog kan vinden.",
      "backHome": "Terug naar home",
      "signInRequired": "Inloggen vereist",
      "signInBody": "Je moet ingelogd zijn om je account te verwijderen.",
      "goSignIn": "Ga naar inloggen",
      "deletedHeading": "Permanent verwijderd",
      "deletedItem1": "Je account, e-mail en wachtwoord",
      "deletedItem2": "Opgeslagen favorieten en meldingen",
      "deletedItem3": "Meldingsabonnementen en apparaatkoppelingen",
      "deletedItem4": "Openstaande meldingen of claimverzoeken",
      "anonHeading": "Geanonimiseerd (publiek bewaard, zonder je naam)",
      "anonItem1": "Recensies die je hebt geschreven — getoond als 'Verwijderde gebruiker'",
      "anonItem2": "Moderatie/audit-logs die al zijn verwerkt",
      "bizHeading": "Als je een bedrijfsvermelding bezit",
      "bizItem1": "Je abonnement wordt direct geannuleerd via Stripe",
      "bizItem2": "De vermelding wordt teruggezet naar niet-geclaimd",
      "bizItem3": "Je kunt hem later opnieuw claimen met een nieuw account",
      "legalHeading": "Bewaard om juridische/fiscale redenen",
      "legalItem1": "Stripe-facturen (Spaanse fiscale wet: 6 jaar bewaring)",
      "legalItem2": "Geanonimiseerd verwijderingsauditlog (2 jaar)",
      "reasonLabel": "Reden van vertrek",
      "reasonPlaceholder": "Help ons verbeteren — waarom vertrek je?",
      "typeDeleteLead": "Typ", "typeDeleteTrail": "om te bevestigen",
      "deleting": "Verwijderen…",
      "deletePermanent": "Verwijder mijn account permanent",
      "cancelKeep": "Annuleren, mijn account behouden",
      "errDefault": "Account kon niet worden verwijderd. Probeer opnieuw of neem contact op."
    },
    "trial": {
      "signupTitle": "Begin met een gratis proefperiode van 60 dagen — geen kaart nodig",
      "signupBody": "Probeer Find-2-Day 60 dagen gratis. Voeg op elk moment vóór dag 60 een betaalmethode toe. Voeg je er geen toe, dan worden je evenementen en aanbiedingen automatisch gepauzeerd — je vermelding blijft zichtbaar.",
      "signupCta": "Start gratis proefperiode van 60 dagen — geen kaart nodig",
      "includesTrialBadge": "Inclusief gratis proefperiode van 60 dagen — geen kaart nodig",
      "instantListingTrialDesc": "Alle bedrijven zijn momenteel 12 maanden gratis onder de Founding Business Aanbieding — geen kaart nodig.",
      "bulletReminders": "We herinneren je 14, 7 en 2 dagen voor het einde van de proef",
      "paymentLabel": "Gratis proef", "pausedLabel": "Gepauzeerd",
      "feedbackPrompt": "Kun je ons vertellen waarom? Dat helpt ons verbeteren.",
      "feedbackThanks": "Bedankt — we waarderen het.",
      "feedbackSend": "Verzenden",
      "feedbackError": "Feedback kon nu niet worden verzonden.",
      "feedbackNotePlaceholder": "Iets toevoegen (optioneel)",
      "reasonNotReady": "Nog niet klaar",
      "reasonPriceTooHigh": "Prijs te hoog",
      "reasonPreferMonthly": "Liever maandelijks betalen",
      "reasonOther": "Anders"
    },
    "safety": {
      "title": "Community-veiligheidshub",
      "subtitle": "Officiële noodupdates, gemeenschapsmeldingen en lokale hulp tijdens incidenten.",
      "disclaimer": "Geen politiedienst. Bel 112 bij een noodgeval. Berichten worden door ons team bekeken vóór publicatie. Geen namen, geen beschuldigingen, geen kentekens, geen privégegevens.",
      "empty": "Nog geen veiligheidsmeldingen voor dit filter.",
      "submitCta": "+ Melding indienen",
      "myPosts": "Mijn berichten",
      "verifiedResident": "Geverifieerde bewoner van {{town}}",
      "publishedOn": "Gepubliceerd {{date}}",
      "allTowns": "Alle plaatsen", "allCategories": "Alle categorieën",
      "category": {
        "incident_factual": "Incident (feitelijk)",
        "safety_tip": "Veiligheidstip",
        "lost_pet": "Zoekgeraakt huisdier",
        "community_alert": "Communitywaarschuwing"
      },
      "report": {
        "button": "Melden",
        "title": "Deze melding rapporteren",
        "placeholder": "Waarom is deze melding problematisch?",
        "submit": "Melding verzenden",
        "thanks": "Bedankt — we bekijken het.",
        "alreadyReported": "Je hebt deze melding al gerapporteerd."
      },
      "filterTown": "Filter op plaats",
      "filterCategory": "Categorie",
      "categoryHint": {
        "incident_factual": "Een korte, feitelijke notitie over wat is gebeurd. Geen namen, geen beschuldigingen.",
        "safety_tip": "Een algemene tip die buren helpt veiliger te zijn.",
        "lost_pet": "Zoekgeraakt huisdier. Beschrijf het dier, het laatst geziene gebied en gebruik het platform voor contact — geen privéadressen.",
        "community_alert": "Kortstondige waarschuwing (automatisch verwijderd na 24 uur)."
      },
      "expiresIn": "Zichtbaar voor {{value}}",
      "submit": {
        "title": "Veiligheidsmelding indienen",
        "intro": "Deel een korte, feitelijke notitie met geverifieerde buren in je plaats. Elk bericht wordt beoordeeld voordat het wordt gepubliceerd.",
        "town": "Plaats (alleen provincie Almería)",
        "townPlaceholder": "Kies je plaats",
        "categoryLabel": "Wat voor soort bericht is dit?",
        "titleLabel": "Titel",
        "titlePlaceholder": "Korte samenvatting (max 80 tekens)",
        "bodyLabel": "Details",
        "bodyPlaceholder": "Alleen platte tekst. Geen links, geen namen, geen beschuldigingen, geen kentekens, geen privégegevens. Max 500 tekens.",
        "rules": "Door in te dienen bevestig ik:",
        "rulesNoNames": "Ik heb niemand met naam genoemd.",
        "rulesNoAccusations": "Ik beschuldig niemand van een misdrijf.",
        "rulesNoPlates": "Ik heb geen kenteken opgenomen.",
        "rulesNoPrivate": "Ik heb geen adres, telefoonnummer of andere privégegevens opgenomen.",
        "confirmCheckbox": "Ik bevestig: geen namen, geen beschuldigingen, geen kentekens, geen privégegevens.",
        "submitButton": "Indienen ter beoordeling",
        "needTown": "Kies een plaats",
        "needTitle": "Voeg een titel toe (minstens 4 tekens)",
        "needBody": "Voeg details toe (minstens 10 tekens)",
        "needConfirm": "Vink het bevestigingsvakje aan",
        "submitting": "Bezig met verzenden…",
        "successTitle": "Ingediend — wacht op beoordeling",
        "successBody": "Ons team bekijkt je bericht. Je ontvangt een e-mail wanneer het is goedgekeurd of als wijzigingen nodig zijn.",
        "characters": "{{count}} tekens",
        "loginRequired": "Log in om een melding in te dienen.",
        "signIn": "Inloggen",
        "rateLimitHit": "Limiet bereikt — je kunt tot 3 meldingen per 24 uur indienen."
      },
      "mine": {
        "empty": "Je hebt nog geen meldingen ingediend.",
        "status": {
          "pending": "Wacht op beoordeling",
          "approved": "Gepubliceerd",
          "rejected": "Niet gepubliceerd",
          "expired": "Verlopen",
          "takedown": "Verwijderd"
        },
        "rejectionReason": "Reden: {{reason}}",
        "back": "Terug naar melding",
        "markFound": "Markeren als gevonden",
        "markFoundSuccess": "Gemarkeerd als gevonden — bedankt voor het doorgeven!",
        "markFoundFailed": "Kon niet als gevonden markeren.",
        "closedFound": "Gesloten — huisdier gevonden",
        "edit": "Bewerken",
        "editHeading": "Melding bewerken",
        "editTown": "Plaats",
        "editCategory": "Categorie",
        "editTitleField": "Titel",
        "editBody": "Details",
        "editPendingNote": "Het bewerken van een gepubliceerde melding stuurt deze terug voor beoordeling voordat hij weer live gaat.",
        "editCancel": "Annuleren",
        "editSave": "Wijzigingen opslaan",
        "editSuccessPending": "Opgeslagen — je melding staat weer in beoordeling en gaat live zodra deze is goedgekeurd.",
        "editSuccessLive": "Je melding is bijgewerkt.",
        "editFailed": "Kon de wijzigingen niet opslaan. Probeer het opnieuw.",
        "editLiveNote": "Je wijziging blijft direct live — volgers worden alleen op de hoogte gebracht als je dat hieronder kiest.",
        "editNotifyFollowers": "Volgers op de hoogte brengen van deze update",
        "editSuccessNotified": "Opgeslagen — je volgers zijn op de hoogte gebracht van de update."
      }
    },
    "guideSubInstant": "Je vermelding staat live zodra je abonnement is bevestigd (of direct bij het starten van een gratis proefperiode van 60 dagen op het 12-maandsplan).",
    "faq2a": "Alle bedrijven zijn momenteel 12 maanden gratis onder de Founding Business Aanbieding — geen kaart nodig, geen betaling tijdens de founding-periode. Toekomstige prijzen (indien geïntroduceerd) worden ruim van tevoren gecommuniceerd.",

    // PASS 2 (Feb 2026)
    "emergency": {
      "title": "Noodnummers",
      "subtitle": "Regio Almería — tik op een nummer om te bellen",
      "disclaimerTitle": "Bij levensbedreigende noodsituatie:",
      "disclaimerBody": "Deze pagina is informatief en geeft mogelijk niet de meest recente officiële contactgegevens weer.",
      "callNow": "bel nu 112",
      "tapToCall": "Tik om te bellen",
      "footerNote": "Laatst bijgewerkt februari 2026. Controleer kritieke informatie altijd bij officiële bronnen.",
      "euEmergency": "Alarmnummer (EU)",
      "euEmergencyDesc": "Alles-in-één nummer voor politie, ambulance en brandweer in de EU",
      "nationalPolice": "Policía Nacional",
      "nationalPoliceDesc": "Nationale politie — ernstige misdrijven, identiteitsdocumenten",
      "guardiaCivil": "Guardia Civil",
      "guardiaCivilDesc": "Landelijke gebieden, wegen en grenzen",
      "localPolice": "Policía Local",
      "localPoliceDesc": "Lokale incidenten, parkeren, gemeentelijke zaken",
      "medical": "Medisch noodnummer",
      "medicalDesc": "Ambulance en spoedeisende zorg",
      "fire": "Brandweer",
      "fireDesc": "Bomberos — branden, reddingen, overstromingen",
      "dvSupport": "Hulp bij huiselijk geweld",
      "dvSupportDesc": "24/7 vertrouwelijke hulplijn (gratis, staat niet op telefoonrekening)",
      "torrecardenas": "Ziekenhuis Torrecárdenas",
      "torrecardenasDesc": "Belangrijkste openbare ziekenhuis in Almería-stad",
      "ukConsulate": "Brits consulaat (Málaga)",
      "ukConsulateDesc": "Hulp voor Britse burgers in Zuid-Spanje",
      "ieConsulate": "Ierse ambassade (Madrid)",
      "ieConsulateDesc": "Hulp voor Ierse burgers — geldt voor heel Spanje",
      "cat": { "primary": "Noodgeval", "police": "Politie", "medical": "Medisch", "fire": "Brand", "support": "Ondersteuning", "consulate": "Consulaat" }
    },
    "holidays": {
      "title": "Feestdagen",
      "subtitle": "Spanje & Andalusië — 2026",
      "nextHoliday": "Volgende feestdag",
      "today": "Vandaag",
      "tomorrow": "Morgen",
      "inNDays": "over {{count}} dagen",
      "footerNote": "Data kunnen per gemeente verschillen. Controleer zo nodig bij je gemeente.",
      "scope": { "national": "Nationaal", "andalusia": "Andalusië", "almeria": "Almería" },
      "month": { "january": "Januari", "february": "Februari", "march": "Maart", "april": "April", "may": "Mei", "june": "Juni", "july": "Juli", "august": "Augustus", "september": "September", "october": "Oktober", "november": "November", "december": "December" },
      "newYear": "Nieuwjaarsdag",
      "epiphany": "Driekoningen",
      "andalusiaDay": "Dag van Andalusië",
      "maundyThursday": "Witte Donderdag",
      "goodFriday": "Goede Vrijdag",
      "labourDay": "Dag van de Arbeid",
      "sanJuan": "San Juan (Almería)",
      "assumption": "Maria-Tenhemelopneming",
      "virgenDelMar": "Virgen del Mar (Almería)",
      "nationalDay": "Spaanse Nationale Feestdag",
      "allSaints": "Allerheiligen (verschoven)",
      "constitutionDay": "Dag van de Grondwet",
      "immaculate": "Onbevlekte Ontvangenis",
      "christmas": "Kerstmis"
    },
    "calendar": {
      "addToCalendar": "Toevoegen aan agenda",
      "icsDownload": "Apple / Outlook (.ics)",
      "icsHint": "Universele agendabestand",
      "googleCalendar": "Google Agenda",
      "googleHint": "Opent in een nieuw tabblad"
    },
    "community": {
      "title": "Community-tools",
      "safetySub": "Geverifieerde buren, feitelijke notities",
      "emergencySub": "Politie, medisch, 112",
      "holidaysSub": "Spanje & Andalusië 2026"
    }
  }
};

export default nl;
